import { call, put, takeEvery } from 'redux-saga/effects';
import * as fieldsConfigActions from '../actions/fieldsActions';
import {
  getResponsibles,
  getCustomersStatuses,
  getPositionsRepresentatives,
} from '../../api/filters';

function* getPositionsRepresentativesSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getPositionsRepresentatives, payload);
    yield put(fieldsConfigActions.getPositionsRepresentativesSuccess(response));
  } catch (error) {
    yield put(fieldsConfigActions.getPositionsRepresentativesError(error));
  }
}

function* getResponsiblesSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getResponsibles, payload);
    yield put(fieldsConfigActions.getResponsiblesSuccess(response));
  } catch (error) {
    yield put(fieldsConfigActions.getResponsiblesError(error));
  }
}

function* getCustomersStatusesSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getCustomersStatuses, payload);
    yield put(fieldsConfigActions.getCustomersStatusesSuccess(response));
  } catch (error) {
    yield put(fieldsConfigActions.getCustomersStatusesError(error));
  }
}

export function* fieldsConfigWatcher() {
  yield takeEvery(
    fieldsConfigActions.getResponsibles.toString(),
    getResponsiblesSaga
  );
  yield takeEvery(
    fieldsConfigActions.getPositionsRepresentatives.toString(),
    getPositionsRepresentativesSaga
  );
  yield takeEvery(
    fieldsConfigActions.getCustomersStatuses.toString(),
    getCustomersStatusesSaga
  );
}
